import React from 'react';
import StatusTag from "./StatusTag";

export default function CompanyCard({ company, imageSource}) {

    const noCompany = company.name === "Vendor Company" || company.name === "Purchaser Company";

    const line2 =
        noCompany
        ? `Company of ${company.name === "Vendor Company" ? "Vendor Rep" : "Purchaser Rep"}`
        : [company.industry, [company.city, company.state].filter(Boolean).join(", ")].filter(Boolean).join(" | ")

    return (
        <div className="company-card">
            <div className="flex-row" style={{alignItems: "center"}}>
                { imageSource 
                    ? <img className="gap-right-s logo iblock" src={imageSource} alt="" role="presentation"></img>
                    : <div></div> 
                    }
                    <h3 className={"title2 iblock " + (noCompany ? "heavy-grey": "heavy")}>{company.name}</h3>
            </div>
            <h4 className={"content1 " + (noCompany ? "light" :"light-black")}>{line2}</h4>
        </div>
    )
}
